import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { CoreModule, FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { PreloaderService } from '@core/services/preloader.service';
import { environment } from '@env/environment';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { GoogleAnalyticalService } from 'app/dp-world/services/google-analytics.service';
import { LoadExternalScriptService } from 'app/dp-world/services/load-external-script.service';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
declare let JSZip: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    CoreModule,
    FlexLayoutModule,
    MatButtonModule,
    MatToolbarModule,
    CarouselModule,
    HttpClientModule
  ],
  providers: [
    { provide: 'googleTagManagerId', useValue: environment.enableGTAGID ? (environment.environmentName === 'Prod' ? environment.GTAG_ID : environment.GTAG_ID_NON_PROD) : 'DUMMY' },
    GoogleTagManagerService,
    GoogleAnalyticalService,
    PreloaderService,
    LoadExternalScriptService
  ],
  templateUrl: './trade-finance-marketing.component.html',
  styleUrls: ['./trade-finance-marketing.component.scss']
})
export class TradeFinanceMarketingComponent implements AfterViewInit {

  scrollY = window.pageXOffset;
  customOptions: OwlOptions = {
    loop: false,
    dots: true,
    touchDrag: true,
    mouseDrag: true,
    pullDrag: true,
    navSpeed: 600,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1,
      },
      700: {
        items: 2
      },
    },
    nav: true,
  };
  webpFormatImg = {
    arrowRight_desktop: '',
    arrowRight_mobile: '',
    citySkyline_desktop: '',
    citySkyline_mobile: '',
    containerShip_desktop: '',
    containerShip_mobile: '',
    manWithTablet_desktop: '',
    manWithTablet_mobile: '',
    peopleDiscussingGraphs_desktop: '',
    peopleDiscussingGraphs_mobile: '',
    personShowingTheExitDoor_desktop: '',
    personShowingTheExitDoor_mobile: '',
    pexelsTomFisk_desktop: '',
    pexelsTomFisk_mobile: '',
    port_desktop: '',
    port_mobile: '',
    portraitOfaManInWarehouse_desktop: '',
    portraitOfaManInWarehouse_mobile: '',
    skyscrapers_desktop: '',
    skyscrapers_mobile: '',
    womanStanding_desktop: '',
    womanStanding_mobile: ''
  }

  connectingWorldCarousel = [{
    imgUrl1: this.webpFormatImg.pexelsTomFisk_desktop,
    imgUrl2: this.webpFormatImg.pexelsTomFisk_mobile,
    desc: `DP World's extensive network across the globe provides visibility on trade data and with
      its capabilities to control the underlying cargo, will help lenders connect with
      businesses, accurately assess risks, derive comfort, and provide credit whilst
      businesses gain access to affordable and innovative financing options.`,
    alt: 'Pexels tom fisk tab'
  },
  {
    imgUrl1: this.webpFormatImg.skyscrapers_desktop,
    imgUrl2: this.webpFormatImg.skyscrapers_mobile,
    desc: `DP World Trade Finance not only works with traditional banking institutions but brings
      in new-age alternative lenders, complimented by establishing its own lending
      capabilities, increasing financing options and capacity for businesses. All these
      businesses are thoroughly vetted, so Financial Institutions can lend with confidence.`,
    alt: 'Skyscrapers tab'
  }];

  benefitsCarousel = [{
    imgUrl1: this.webpFormatImg.portraitOfaManInWarehouse_desktop,
    imgUrl2: this.webpFormatImg.portraitOfaManInWarehouse_mobile,
    heading: 'For business owners',
    desc1: `From SMEs to fledgling entrepreneurs and large corporates, the primary advantage of what DP
    World Trade Finance offers is accessibility. Businesses that partner with us can quickly
    increase order flow and reach international customers that were previously inaccessible due
    to financial barriers.`,
    desc2: `Our platform is focused on finding the best solution for businesses, as quickly as possible.
    We enable swift access to working capital solutions by digitising trade documentation to
    offer better control to financiers and help businesses become bankable.`,
    alt: 'Warehouse portrait tab'
  },
  {
    imgUrl1: this.webpFormatImg.womanStanding_desktop,
    imgUrl2: this.webpFormatImg.womanStanding_mobile,
    heading: 'For financial institutions',
    desc1: `As a leading smart logistics provider, we have been connecting geographies and businesses
    for over 50 years. During this time, we have built a network of elite financial partners -
    and our portfolio is always growing.`,
    desc2: `We know that information is important to them, so we utilise the power of the wider DP World
    network to bring real trade data passing through our global ports and logistics network to
    give Financial Institutions the visibility and control they need to accurately assess credit
    and compliance risks.`,
    alt: 'Woman Standing tab'
  }];

  authoritiesCarouselOptions: OwlOptions = {
    loop: false,
    dots: true,
    touchDrag: true,
    mouseDrag: true,
    pullDrag: true,
    navSpeed: 600,
    responsive: {
      0: {
        items: 1,
      },
      700: {
        items: 4
      },
    },
    nav: false,
  };

  authoritiesCarouselData = [
    {
      imgUrl1: 'https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/FCI-tab.jpg',
      imgUrl2: 'https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/FCI-mobile.jpg',
      alt: 'FCI'
    },
    {
      imgUrl1: 'https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/baft-tab.jpg',
      imgUrl2: 'https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/baft-mobile.jpg',
      alt: 'BAFT'
    },
    {
      imgUrl1: 'https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/international-chamber-of-commerce-icc-logo-tab.jpg',
      imgUrl2: 'https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/icc-mobile.jpg',
      alt: 'ICC'
    },
    {
      imgUrl1: 'https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/itfa-logo-tab.jpg',
      imgUrl2: 'https://cargoesfinancestaging.blob.core.windows.net/static-images-marketing-page/staging/itfa-mobile.jpg',
      alt: 'ITFA'
    }
  ];

  constructor(private googleAnalytics: GoogleAnalyticalService,
    private preloader: PreloaderService,
    private httpClient: HttpClient,
    private loadExternalScriptService: LoadExternalScriptService) {
    this.googleAnalytics.pushTag({ eventdetail: null });
    this.loadExternalScriptService.load('jszip').then(() => {
      this.getAndProcessImages();
    });
  }

  signUp(ctaPosition: string): void {
    let url = `https://qa-finance.dpworld.com/create-account`;
    if (window.location.host === 'tradefinance.dpworld.com') {
      url = `https://finance.dpworld.com/create-account`;
    }
    const gtmTag = {
      event: 'dl_cfctaclick',
      eventdetail: {
        eventCategory: 'Cargo Finance - New',
        eventAction: 'Apply Now Click',
        eventLabel: ctaPosition
      }
    };
    this.googleAnalytics.pushTag(gtmTag);
    window.open(url, '_self');
  }

  loginToTradeFinance(ctaPosition: string): void {
    let url = `https://qa-finance.dpworld.com`;
    if (window.location.host === 'tradefinance.dpworld.com') {
      url = `https://finance.dpworld.com`;
    }
    const gtmTag = {
      event: 'dl_cfctaclick',
      eventdetail: {
        eventCategory: 'Cargo Finance - New',
        eventAction: 'Sign In Click',
        eventLabel: ctaPosition
      }
    };
    this.googleAnalytics.pushTag(gtmTag);
    window.open(url, '_self');
  }

  openGeneralPoliciesTab(policyType: string): void {
    let url = `https://qa-finance.dpworld.com/policies/${policyType}`;
    if (window.location.host === 'tradefinance.dpworld.com') {
      url = `https://finance.dpworld.com/policies/${policyType}`;
    }
    window.open(url, '_self');
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (window.innerWidth > 768) {
      const element = document.getElementById('page-header');
      const scrollY = window.pageYOffset;
      if (this.scrollY <= 68) {
        element.classList.remove('sticky-unpinned');
        element.classList.remove('sticky-pinned');
      } else {
        if (window.pageYOffset < this.scrollY) {
          element.classList.add('sticky-pinned');
          element.classList.remove('sticky-unpinned');
        } else {
          element.classList.remove('sticky-pinned');
          element.classList.add('sticky-unpinned');
        }
      }
      this.scrollY = scrollY;
    }
  }

  getAndProcessImages(): void {
    this.httpClient.get('assets/images/webP-format.zip', { responseType: 'blob' }).subscribe((response) => {
      const blob = new Blob([response], { type: 'application/zip' });
      const fileReader: FileReader = new FileReader();
      const $this = this;
      fileReader.onloadend = async function (x) {
        const jsZip = typeof JSZip.default === "function" ? new JSZip.default() : new JSZip();
        const zip = await jsZip.loadAsync(blob);
        Object.keys(zip.files).forEach(async (filename: string) => {
          const fileData = await zip.files[filename].async('base64');
          const image = "data:image/webp;base64," + fileData;
          const imageKey = Object.keys($this.webpFormatImg).find(key => filename.includes('/' + key));
          if (imageKey) {
            $this.webpFormatImg[imageKey] = image;
            switch (imageKey) {
              case 'pexelsTomFisk_desktop':
                $this.connectingWorldCarousel[0].imgUrl1 = $this.webpFormatImg[imageKey];
                break;
              case 'pexelsTomFisk_mobile':
                $this.connectingWorldCarousel[0].imgUrl2 = $this.webpFormatImg[imageKey];
                break;
              case 'skyscrapers_desktop':
                $this.connectingWorldCarousel[1].imgUrl1 = $this.webpFormatImg[imageKey];
                break;
              case 'skyscrapers_mobile':
                $this.connectingWorldCarousel[1].imgUrl2 = $this.webpFormatImg[imageKey];
                break;
              case 'portraitOfaManInWarehouse_desktop':
                $this.benefitsCarousel[0].imgUrl1 = $this.webpFormatImg[imageKey];
                break;
              case 'portraitOfaManInWarehouse_mobile':
                $this.benefitsCarousel[0].imgUrl2 = $this.webpFormatImg[imageKey];
                break;
              case 'womanStanding_desktop':
                $this.benefitsCarousel[1].imgUrl1 = $this.webpFormatImg[imageKey];
                break;
              case 'womanStanding_mobile':
                $this.benefitsCarousel[1].imgUrl2 = $this.webpFormatImg[imageKey];
                break;
            }
          }
        });
      };
      fileReader.readAsText(blob);
    });
  }

  ngAfterViewInit() {
    // console.log('ngAfterViewInit; hiding global loader!');
    this.preloader.hide();
  }
}
